module.exports = __webpack_public_path__ + "src-notif-egencia.png?58f95ea18bc36665bbf73af64d21d669";